import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNavAgentCenter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0,-960) scale(40)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M15.5349 8.4638C17.5878 10.5167 18.9559 12.7963 19.54 14.7822C20.136 16.8091 19.8619 18.279 19.0705 19.0704C18.279 19.8618 16.8092 20.136 14.7823 19.54C12.7963 18.9559 10.5168 17.5878 8.46387 15.5349C6.41098 13.482 5.04286 11.2024 4.45877 9.21648C3.86277 7.18957 4.13691 5.71969 4.92833 4.92826C5.71976 4.13684 7.18964 3.8627 9.21655 4.4587C11.2025 5.04279 13.482 6.41091 15.5349 8.4638Z",
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.4638 8.46409C10.5167 6.4112 12.7963 5.04308 14.7822 4.45899C16.8091 3.86299 18.279 4.13713 19.0704 4.92855C19.8618 5.71998 20.136 7.18986 19.54 9.21677C18.9559 11.2027 17.5878 13.4823 15.5349 15.5352C13.482 17.588 11.2024 18.9562 9.21648 19.5403C7.18957 20.1363 5.71969 19.8621 4.92826 19.0707C4.13684 18.2793 3.8627 16.8094 4.4587 14.7825C5.04279 12.7966 6.41091 10.517 8.4638 8.46409Z",
				stroke: "currentColor",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", { d: "M12 8.5L13.0592 10.9408L15.5 12L13.0592 13.0592L12 15.5L10.9408 13.0592L8.5 12L10.9408 10.9408L12 8.5Z" })
		]
	})
});
export default SvgNavAgentCenter;
